import { render, staticRenderFns } from "./ModalGetPrice.vue?vue&type=template&id=4fcdaa48&scoped=true&"
import script from "./ModalGetPrice.vue?vue&type=script&lang=js&"
export * from "./ModalGetPrice.vue?vue&type=script&lang=js&"
import style0 from "./ModalGetPrice.vue?vue&type=style&index=0&id=4fcdaa48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcdaa48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fcdaa48')) {
      api.createRecord('4fcdaa48', component.options)
    } else {
      api.reload('4fcdaa48', component.options)
    }
    module.hot.accept("./ModalGetPrice.vue?vue&type=template&id=4fcdaa48&scoped=true&", function () {
      api.rerender('4fcdaa48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/ModalGetPrice.vue"
export default component.exports